import { useContext, useMemo } from 'react';
import type * as React from 'react';
import { CardContext } from '../../utils/cardContext';
import { Responsive } from '@cian/ui-kit';
import { LayoutsLinks } from '../../components/Building/parts/LayoutsLinks';
import { LayoutsLinksMobile } from '../../components/Building/parts/LayoutsLinksMobile';

export const LayoutLinks = (): React.JSX.Element => {
  const { layoutStats, id, builders } = useContext(CardContext);

  const layoutsUrl = useMemo(() => builders[0].layoutsUrl, [builders]);

  return (
    <>
      <Responsive desktop>
        <LayoutsLinks layoutStats={layoutStats} newbuildingId={id} />
      </Responsive>

      <Responsive phone tablet>
        <LayoutsLinksMobile layoutStats={layoutStats} layoutsUrl={layoutsUrl} newbuildingId={id} />
      </Responsive>
    </>
  );
};
